__turbopack_context__.v({
  "figure": "ozbI6G_figure",
  "fullWidth": "ozbI6G_fullWidth",
  "hyperlink": "ozbI6G_hyperlink",
  "resourceArticle": "ozbI6G_resourceArticle",
  "richTextContainer": "ozbI6G_richTextContainer",
});
